import React from 'react';
import { BargainPriceItem } from '../../../models/bargain-price-item.entity';
import i18n from '../../../i18n';
import Card from '../Card';
import { Box, Grid, Typography } from '@mui/material';
import { ArrowBackIos, Save, ViewDay } from '@mui/icons-material';
import CommonInput from '../../../component/form/common-input.component';
import _ from 'lodash';
import ButtonComponent from '../../../component/button/button.component';
import MenuListComponent, { MenuListItem } from '../menu-list/menu-list-component';
import { FirstMenu, MenuDish } from '../../../models';


/**
 * 菜品沽清详情
 */
class DishSoldOutDetail extends React.Component<Props, State> {

    public state: Readonly<State> = {
        // 防止多次点击
        isLoading: false,
        // 当前选中项目
        selectedRowIds: [],
        selectedRows: [],
        // 关键词
        searchValue: ''
    }
    // *********************
    // Life Cycle Function
    // *********************

    // *********************
    // Default Function
    // *********************

    /**
     * 表单回调
     * @param value
     * @param key
     */
    onChange(value: number | string, key: string) {
        const detail = this.props.detail;
        let selectDetails = this.props.selectDetails
        let newValue = value;
        if ((key === 'bargain_num_cur') || (key === 'bargain_num')) {
            if (value && Number(value) < 0) {
                newValue = 0
            }
            else if (value) {
                newValue = Number(Number(value).toFixed(2))
            }
        }
        _.set(detail, key, newValue)
        selectDetails = selectDetails.map(n => {
            _.set(n, key, newValue)
            return n
        })
        this.props.updateState({
            detail,
            selectDetails
        })
    }
    /**
     * 修改搜索关键词
     */
    onChangSearchValue(value: string) {
        this.setState({ searchValue: value }, () => {
            this.props?.getMenuForSearch?.(value.trim());
        });
    }

    /**
     * 选中/反选
     * @param menu
     * @param index
     */
    handleClick(menu: MenuListItem,) {
        if (menu.type === 'MenuDish') {
            const { dataSource } = menu;
            let { selectedRowIds, selectedRows } = this.state;
            const index = selectedRowIds.indexOf(dataSource.item_id);

            if (index < 0) {
                // 单选
                if (this.props.isRadio) {
                    selectedRowIds = [];
                    selectedRows = [];
                }
                selectedRowIds.push(dataSource.item_id)
                selectedRows.push(dataSource)
            } else {
                selectedRowIds.splice(index, 1)
                selectedRows.splice(index, 1)
            }
            const item = selectedRows?.[0] || {};
            const afterSelectDetails = selectedRows.map(n => {
                const param = {
                    ...this.props.detail,
                    bargain_item_name: n.item_name1,
                    bargain_item_number: n.item_id,
                }
                return param
            })
            this.props.updateState(() => ({
                selectDetails: afterSelectDetails,
                details: {
                    ...this.props.detail,
                    bargain_item_name: item.item_name1,
                    bargain_item_number: item.item_id,
                }
            }))
            this.setState({
                selectedRows,
                selectedRowIds
            })
        }
    }

    onSave = () => {

    }

    /**
     * 返回
     */
    onGoBack = () => {
        this.setState({})
        this.props.updateState({ details: undefined });
        this.props.onClose()
    }

    // *********************
    // View
    // *********************

    render() {
        const { detail, selectDetails } = this.props;
        const { menuData, filterDishId, filterDishArr, dishGroupSelectedId, isShowPackage, isSellOut, } = this.props;

        const { selectedRowIds, searchValue } = this.state;
        // 表单
        const formArr = [
            // 沽清类型：
            {
                key: 'bargain_stype',
                label: `10901 ${i18n.t('dish_sold_out_page_sell_out_type')}`,
                select: true,
                items:
                    [
                        {
                            value: 1,
                            label: i18n.t('dish_sold_out_page_manual_sell_out')
                        },
                        {
                            value: 2,
                            label: i18n.t('dish_sold_out_page_amount_sell_out')
                        },
                        {
                            value: 3,
                            label: i18n.t('dish_sold_out_page_day_sell_out')
                        }]
            },
            // 10902 可销售数量
            {
                key: 'bargain_num',
                label: i18n.t('dish_sold_out_page_10902_can_sell_amount'),
                type: 'number',
                hide: detail?.['bargain_stype'] !== 2
            },
            // 10906 可用数量
            {
                key: 'bargain_num_cur',
                label: i18n.t('dish_sold_out_page_10906_can_use_amount'),
                type: 'number',
                hide: detail?.['bargain_stype'] !== 2
            },
            // 10903 日结后恢复数量：1是, 0不是
            {
                key: 'is_every_day',
                label: i18n.t('dish_sold_out_page_10903_day_settle_renew_amount'),
                select: true,
                items:
                    [{
                        value: 1,
                        label: i18n.t('google_text_yes')
                    },
                    {
                        value: 0,
                        label: i18n.t('google_text_no')
                    }],
                hide: detail?.['bargain_stype'] !== 2
            }
        ]
        const menu = menuData.map((item) => {
            // 第一层就是菜品（用于菜品搜索）
            const isMenuDish = _.get(item, 'type') === 'MenuDish';
            return {
                key: `${item.main_group_id}`,
                title: item.main_group_name ?? '',
                type: _.get(item, 'type', 'FirstMenu'),
                checkedSecondMenuIds: isMenuDish ? selectedRowIds : undefined,
                originId: isMenuDish ? _.get(item, 'item_id') : undefined,
                children: isMenuDish ? undefined : (item.menu_item_slu || []).reduce((res: MenuListItem[], subMenuItem) => {
                    if (subMenuItem.dmi_slu_id === dishGroupSelectedId) return res
                    res.push({
                        key: `sub-${subMenuItem.dmi_slu_id}`,
                        title: subMenuItem.dmi_slu_name ?? '',
                        dataSource: subMenuItem,
                        type: 'SecondMenu',
                        children: (subMenuItem.menu_item || [])
                            .filter((menuItem) => {
                                // 区分菜品沽清
                                let filterFlag: boolean =
                                    (isShowPackage || menuItem.item_type !== 3) && filterDishId !== menuItem.item_id && _.indexOf(filterDishArr, menuItem.item_id) === -1
                                if (isSellOut) {
                                    filterFlag =
                                        filterDishId !== menuItem.item_id && _.indexOf(filterDishArr, menuItem.item_id) === -1
                                }
                                return filterFlag
                            })
                            .map((menuItem) => ({
                                type: 'MenuDish',
                                key: `menu-${menuItem.item_id}`,
                                title: menuItem.item_name1 || '',
                                secondTitle: menuItem.item_name2 || '',
                                dataSource: menuItem,
                                checkedSecondMenuIds: selectedRowIds,
                                originId: menuItem.item_id
                            })),

                    })
                    return res
                }, []),
                dataSource: item,
            }
        })
        return (
            <Card
                title={(
                    <Box display='flex' alignItems='center'>
                        <ButtonComponent
                            titleText={i18n.t('google_text_return')}
                            children={<ArrowBackIos className='arrow-icon-center' />}
                            handleClick={this.onGoBack}
                        />
                        <Typography variant='h6' marginLeft={3}>
                            {
                                ((detail.bargain_item_id || (detail.bargain_item_id === 0)) && detail.bargain_item_id !== -1)
                                    ?
                                    i18n.t('dish_sold_out_page_edit_dish_sell_out')
                                    :
                                    i18n.t('dish_sold_out_page_add_dish_sell_out')
                            }
                        </Typography>
                    </Box>
                )}
                actionRender={(
                    <>
                        <ButtonComponent
                            async
                            titleText={i18n.t('order_cart_page_text_reset_dish_sold_out')}
                            handleClick={this.props.onResetSellOut}
                        >
                            <ViewDay />
                        </ButtonComponent>
                        <ButtonComponent
                            async
                            titleText={i18n.t('global_btn_save')}
                            children={<Save />}
                            handleClick={async () => {
                                await this.props.onSave();
                            }}
                        />
                    </>


                )}
                contentRender={(
                    <>
                        <Grid container spacing={4} >
                            {
                                formArr.map((item) => (
                                    !item?.hide &&
                                    <Grid key={item.key} item xs={12} sm={6} lg={4}>
                                        <CommonInput
                                            type={item.type}
                                            variant={'outlined'}
                                            fullWidth
                                            label={item.label}
                                            value={_.get(detail, item.key) ?? ''}
                                            onChange={(event: any) => {
                                                this.onChange(event.target.value, item.key)
                                            }}
                                            select={item.select}
                                            items={item.items}
                                        />
                                    </Grid>
                                ))
                            }
                            <Grid item xs={12}>
                                <Typography>{i18n.t('dish_sold_out_page_10904_sell_out_dish')}</Typography>
                                <Box>
                                    {/* <ActionButton
                                    action='ADD'
                                    onClick={() => { this.props.updateState({ isAddDishDialogOpen: true }) }}
                                /> */}
                                    {detail?.bargain_item_number &&
                                        (
                                            <Box display={'flex'} alignItems={'center'} flexWrap={'wrap'} marginRight={5}>
                                                {selectDetails.map((item, index) => {
                                                    return (
                                                        <ButtonComponent
                                                            titleText={item?.bargain_item_name}
                                                            key={index}
                                                            handleClick={() => {
                                                                // this.props.updateState({ isAddDishDialogOpen: true })
                                                            }}
                                                        >
                                                            {item?.bargain_item_name}
                                                        </ButtonComponent>
                                                    )
                                                })}
                                            </Box>
                                        )
                                    }

                                </Box>

                            </Grid>
                            <Grid item xs={4}>
                                <CommonInput
                                    variant={'outlined'}
                                    fullWidth
                                    label={i18n.t('google_text_please_enter_a_keyword')}
                                    value={searchValue}
                                    onChange={(event: any) => {
                                        this.onChangSearchValue(event.target.value);
                                    }}
                                    allowClear
                                />
                            </Grid>
                        </ Grid>
                        <MenuListComponent
                            style={{ height: '435px' }}
                            fullWidth
                            isHideContextMenu={true}
                            menu={menu}
                            isShowSecondTitle={isSellOut}
                            isShowCheckBox={true}
                            handleClick={(menu) => {
                                this.handleClick(menu)
                            }}
                            isHideAddBtn
                        />
                    </>

                )}
            />

        )
    }
}

export default DishSoldOutDetail;

// *********************
// Type
// *********************
type Props = {
    // 详情
    detail: BargainPriceItem;
    // 刷新数据
    getData: (id: number) => void;
    // 更新父级state
    updateState: (newState: any) => void;
    // 保存
    onSave: () => Promise<void>;
    // 选中的沽清菜品
    selectDetails: BargainPriceItem[];
    // 获取关键词菜单
    getMenuForSearch?: (value: string) => void;
    // 菜单源数据
    menuData: FirstMenu[];
    // 需要剔除的菜品
    filterDishId?: number;
    // 需要剔除的菜品
    filterDishArr?: number[];
    // 基础信息-套餐区域选择的菜单id
    dishGroupSelectedId?: number | string;
    // 是否展示套餐
    isShowPackage?: boolean;
    // 沽清菜品
    isSellOut?: boolean;
    // 单选
    isRadio?: boolean;
    onClose: () => void;
    // 重置沽清
    onResetSellOut: () => void;
}
type State = {
    // 防止多次点击
    isLoading: boolean;
    // 当前选中项目
    selectedRowIds: number[];
    selectedRows: MenuDish[];
    //
    searchValue: string;
}